export const isNameValid = (name: string): boolean => {
  if (name.length < 3) {
    return false;
  }
  return true;
};

export const isEmailValid = (email: string): boolean => {
  const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
  if (!email) {
    return false;
  }
  if (email.startsWith(".") || email.endsWith(".")) {
    return false;
  }
  if (email.includes("..")) {
    return false;
  }
  if (/\s/.test(email)) {
    return false;
  }
  return emailRegex.test(email);
};

export const isDocumentValid = (document: string): boolean => {
  document = document.replace(/\D/g, "");

  if (document.length !== 11 || /^(\d)\1+$/.test(document)) {
    return false;
  }
  let sum = 0;
  let remainder;
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(document[i - 1]) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  if (remainder !== parseInt(document[9])) {
    return false;
  }
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(document[i - 1]) * (12 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  if (remainder !== parseInt(document[10])) {
    return false;
  }
  return true;
};

export const isBirthDateValid = (dateString: string): boolean => {
  const regex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!regex.test(dateString)) {
    return false;
  }
  const [day, month, year] = dateString.split("/").map(Number);
  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return false;
  }
  const inputDate = new Date(year, month - 1, day);
  const currentDate = new Date();
  if (inputDate >= currentDate) {
    return false;
  }
  const minAgeDate = new Date();
  minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
  if (inputDate > minAgeDate) {
    return false;
  }
  return true;
};

export const isPhoneValid = (phone: string): boolean => {
  phone = phone.replace(/\D/g, "");
  if (phone.length < 10) {
    return false;
  }
  return true;
};

export const isSignValid = (name: string): boolean => {
  if (name.length < 8) {
    return false;
  }
  return true;
};

export const isInitialValid = (name: string): boolean => {
  if (name.length < 2) {
    return false;
  }
  return true;
};